(function () {
  function reveal(scope) {
    var els = (scope || document).querySelectorAll('.mg-rv:not(.vis)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window) || (window.Shopify && Shopify.designMode)) {
      els.forEach(function (el) { el.classList.add('vis'); });
      return;
    }
    var o = new IntersectionObserver(function (e) {
      e.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('vis'); o.unobserve(x.target); } });
    }, { threshold: .08, rootMargin: '0px 0px -50px 0px' });
    els.forEach(function (el) { o.observe(el); });
  }
  function pickThumb(t) {
    var hero = t.closest('.mg-hero');
    var main = hero && hero.querySelector('.mg-gal__main');
    if (main && t.dataset.f) {
      main.style.opacity = 0;
      setTimeout(function () { main.src = t.dataset.f; main.style.opacity = 1; }, 200);
    }
    if (hero) hero.querySelectorAll('.mg-gal__thumbs img').forEach(function (x) { x.classList.remove('on'); });
    t.classList.add('on');
  }
  function pickTier(t) {
    var hero = t.closest('.mg-hero');
    if (!hero) return;
    hero.querySelectorAll('.mg-tier').forEach(function (x) { x.classList.remove('on'); });
    t.classList.add('on');
    var btn = hero.querySelector('.js-cta');
    if (!btn) return;
    var p = t.dataset.price;
    btn.textContent = btn.dataset.label + (p ? ' · ' + p : '');
    btn.dataset.href = t.dataset.href || '';
  }
  document.addEventListener('click', function (ev) {
    var t = ev.target.closest && ev.target.closest('.mg-gal__thumbs img, .mg-tier, .mg-fq__q, .js-cta');
    if (!t) return;
    if (t.matches('.mg-gal__thumbs img')) pickThumb(t);
    else if (t.matches('.mg-tier')) pickTier(t);
    else if (t.matches('.mg-fq__q')) t.parentElement.classList.toggle('open');
    else if (t.dataset.href) location.href = t.dataset.href;
  });
  document.addEventListener('shopify:section:load', function (ev) { reveal(ev.target); });
  document.addEventListener('shopify:block:select', function (ev) {
    var t = ev.target;
    if (t.matches('.mg-fq')) t.classList.add('open');
    else if (t.matches('.mg-gal__thumbs img')) pickThumb(t);
    else if (t.matches('.mg-tier')) pickTier(t);
  });
  reveal();
})();
